import { Record } from 'immutable';

import CommonAction from './common.actions';

const initData = {
  error: '',
  loading: false,
  message: '',
  navCollapsed: true,
  width: window.innerWidth,
  pathname: '/',
};

const initialState = new Record(initData)(initData);

export default function commonReducer(state = initialState, action) {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return state.set('pathname', action.payload.location.pathname).set('navCollapsed', false);
    case CommonAction.ACTION_TYPES.WINDOW_WIDTH:
      return state.set('width', action.payload);

    case CommonAction.ACTION_TYPES.TOGGLE_COLLAPSED_NAV: {
      return state.set('navCollapsed', action.navCollapsed);
    }
    case CommonAction.ACTION_TYPES.FETCH_START: {
      return state.set('error', '').set('message', '').set('loading', true);
    }
    case CommonAction.ACTION_TYPESFETCH_SUCCESS: {
      return state.set('error', '').set('message', '').set('loading', false);
    }
    case CommonAction.ACTION_TYPESSHOW_MESSAGE: {
      return state.set('error', '').set('message', action.payload).set('loading', false);
    }
    case CommonAction.ACTION_TYPESFETCH_ERROR: {
      return state.set('error', action.payload).set('message', '').set('loading', false);
    }
    case CommonAction.ACTION_TYPES.HIDE_MESSAGE: {
      return state.set('error', '').set('message', '').set('loading', false);
    }
    default:
      return state;
  }
}
